<template>
  <div>
    <v-btn
      v-if="circle"
      v-tooltip.top="$t('abbreviated_tax_invoice')"
      outline
      :loading="isLoading"
      :disabled="isLoading || orders.length == 0"
      small
      fab
      color="primary"
      @click="handlePrintPDF"
    >
      <i class="fas fa-file-invoice"></i>
    </v-btn>
    <v-btn
      v-else
      :loading="isLoading"
      :disabled="isLoading || orders.length == 0"
      outline
      color="grey"
      @click="handlePrintPDF"
    >
      <i class="fas fa-file-invoice"></i>
      &nbsp;{{ $t('abbreviated_tax_invoice') }}
    </v-btn>
  </div>
</template>
<script>
import THBText from 'thai-baht-text'
import { mapGetters } from 'vuex'
import { seagull } from '../seagullBase64.js'
import dayjs from 'dayjs'
import pdfMake from 'pdfmake/build/pdfmake.js'
import pdfFonts from '@/assets/fonts/vfs_fonts.js'
pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  }
}
export default {
  props: {
    orders: {
      type: [Array],
      default: () => []
    },
    circle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    handleOrderNumber(order) {
      const orderYear = this.handleCreateOrderYear(order)
      return `SC${orderYear || 'XX'}${order.id || 'XXXXXX'}`
    },
    handleCreateOrderYear(order) {
      if (order.timestamp) {
        try {
          let fullYear = new Date(order.timestamp).getFullYear()
          fullYear = fullYear + 543
          fullYear = fullYear + ''
          return fullYear.substring(2, fullYear.length)
        } catch (error) {
          return 'XX'
        }
      } else {
        return 'XX'
      }
    },
    handleTaxPayload(order) {
      if (order && order.tax_address_json) {
        let taxData = null
        taxData = JSON.parse(order.tax_address_json)
        if (taxData && taxData.tax_address && taxData.tax_id && taxData.tax_name) {
          return taxData
        }
      }
      return {
        tax_address: order.nameaddress,
        tax_id: '',
        tax_name: `${order.first_name} ${order.last_name}`
      }
    },
    handleProductList(order) {
      if (order && order.productdetail) {
        let productList = []
        try {
          productList = JSON.parse(order.productdetail)
        } catch (error) {
          productList = order.productdetail
        }
        if (typeof productList == 'object' && productList.length) {
          return productList
        }
      }
      return []
    },
    handleGenerateTemplate(order, index) {
      const productRows =
        this.handleProductList(order).length > 0
          ? this.handleProductList(order).map((product) => [
              `${product.sku ? `SKU ${product.sku}` : ''} ${product.name}`,
              `${product.quantity}`,
              `${(product.price / product.quantity).toFixed(2)}`,
              `${product.price.toFixed(2)}`
            ])
          : ['', '', '', '']
      const totalPrice = (parseInt(order.total) - parseInt(order.shippingcharge)).toFixed(2)
      return [
        {
          columns: [
            {
              image: seagull.icon,
              width: 70
            },
            {
              width: '*',
              text: [
                { text: 'บริษัท ไทยสเตนเลสสตีล จำกัด\n', bold: true },
                { text: 'เลขที่ 10 ซ.สุขุมวิท 61 ถ.สุขุมวิท คลองตันเหนือ วัฒนา กรุงเทพ 10110\n' },
                { text: 'เลขประจำตัวผู้เสียภาษีอากร 0105514003352\n' }
              ]
            },
            {
              width: '25%',
              text: [
                { text: 'ใบกำกับภาษีแบบย่อ (TAX INVOICE)\n', bold: true, alignment: 'right' },
                { text: `เลขที่ ${this.handleOrderNumber(order)}\n`, alignment: 'right' },
                {
                  text: `วันที่ ${dayjs(order.timestamp).format('DD/MM/YYYY')}\n`
                }
              ],
              alignment: 'right'
            }
          ],
          columnGap: 10
        },
        {
          columns: [
            {
              width: '*',
              text: [
                { text: 'ผู้ซื้อ: ', bold: true },
                { text: this.handleTaxPayload(order).tax_name }
              ],
              margin: [0, 5, 0, 0]
            }
          ]
        },
        {
          columns: [
            {
              width: '*',
              text: [
                { text: 'ที่อยู่ผู้จัดส่ง: ', bold: true },
                { text: this.handleTaxPayload(order).tax_address }
              ]
            }
          ]
        },
        this.handleTaxPayload(order).tax_id
          ? {
              columns: [
                {
                  width: '*',
                  text: [
                    { text: 'เลขประจำตัวผู้เสียภาษี: ', bold: true },
                    { text: this.handleTaxPayload(order).tax_id }
                  ]
                }
              ]
            }
          : {},
        {
          columns: [
            {
              width: '*',
              text: [{ text: 'เลขที่ออเดอร์: ', bold: true }, { text: order.id }]
            }
          ]
        },
        {
          columns: [
            {
              width: '*',
              text: [
                { text: 'ช่องทางการชำระเงิน: ', bold: true },
                { text: this.$t(order.transactionid) }
              ],
              margin: [0, 0, 0, 5]
            }
          ]
        },
        {
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['*', 60, 60, 60],

            body: [['รายการสินค้า', 'จำนวน', 'ราคาต่อหน่วย', 'ยอดรวม'], ...productRows]
          }
        },
        {
          columns: [
            {
              width: '*',
              text: [{ text: 'หมายเหตุ: ', bold: true }, { text: '-' }],
              margin: [0, 5, 0, 5]
            }
          ]
        },
        {
          columns: [
            {
              width: '68%',
              stack: []
            },
            {
              width: '15%',
              stack: [
                { text: 'รวม', bold: true },
                { text: 'ส่วนลด', bold: true },
                { text: 'ค่าจัดส่ง', bold: true },
                { text: 'ราคารวมภาษีมูลค่าเพิ่ม', bold: true }
              ],
              alignment: 'right'
            },
            {
              width: '12%',
              stack: [
                { text: `${totalPrice}` },
                { text: `${order.discount}` },
                { text: `${order.shippingcharge}` },
                { text: `${order.amount}` }
              ],
              alignment: 'right'
            },
            {
              width: '5%',
              stack: [{ text: ' บาท' }, { text: ' บาท' }, { text: ' บาท' }, { text: ' บาท' }],
              alignment: 'right'
            }
          ]
        },
        {
          columns: [
            {
              width: '*',
              text: [
                {
                  text: 'จำนวนเงินเป็นตัวอักษร: ',
                  bold: true
                },
                {
                  text: `${THBText(order.amount)}`,
                  bold: true
                }
              ],
              margin: [0, 5, 0, 0],
              alignment: 'center',
              pageBreak: index + 1 === this.orders.length ? '' : 'after'
            }
          ]
        }
      ]
    },
    async handlePrintPDF() {
      try {
        if (!this.selectedBot.pageid) return
        this.loading = true
        const contents = this.orders.map((order, index) =>
          this.handleGenerateTemplate(order, index)
        )
        const docDefinition = {
          content: [contents],
          pageSize: 'A4',
          pageMargins: [25, 25, 25, 25],
          defaultStyle: {
            font: 'THSarabunNew'
          }
        }
        pdfMake.createPdf(docDefinition).open()
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Seagull/PrintAbbreviatedTaxInvoice.vue